import React, { Fragment } from "react";
import "containers/Projects/ActiveProject/Step_3/LearnNewSkill/LearnNewSkill.css";
import ProjectOldInfo from "components/Project/Details/ProjectOldInfo";
import Project_logo from "site_media/images/project_default.jpg";
import SpreadTheWordSummary from "components/Project/ActiveProject/ProjectComplete/SpreadTheWordSummary";
import LearnNewSkillSummary from "components/Project/ActiveProject/ProjectComplete/LearnNewSkillSummary";
import DevelopNewHabitSummary from "components/Project/ActiveProject/ProjectComplete/DevelopNewHabitSummary";
import VolunteerTimeSummary from "components/Project/ActiveProject/ProjectComplete/VolunteerTimeSummary";
import GiveADonationSummary from "components/Project/ActiveProject/ProjectComplete/GiveADonationSummary";
import FundraiseSummary from "components/Project/ActiveProject/ProjectComplete/FundraiseSummary";
import RaiseYourVoiceSummary from "components/Project/ActiveProject/ProjectComplete/RaiseYourVoiceSummary";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton.js";
import AxiosConfig from "../../../../axiosConfig";
import ProjectBanner from "../../../../components/Project/ProjectBanner";

/**
 * @description Displays the prize earned by a user after completion of the project.
 * @class ProjectCompleteComponent
 * @implements ProgressStepper, ProjectBanner, ProjectInfo, SpreadTheWordSummary, LearnNewSkillSummary,
 * DevelopNewHabitSummary, GiveADonationSummary, FundraiseSummary, RaiseYourVoiceSummary
 * @extends React.Component
 * @type {ProjectCompleteComponent}
 * @example <ProjectCompleteComponent />
 * pre-condition: all the imports
 * post-condition: returnsimport { RoundedButton } from 'components/General/Form/CustomButton/RoundedButton';
 a form with the prize earimport RoundedButton from './../../../General/Form/CustomButton/RoundedButton';
ned by the user.import { RoundedButton } from 'components/General/Form/CustomButton/RoundedButton';
import { RoundedButton } from 'components/General/Form/CustomButton/RoundedButton';

 * @param project_banner, project_name, project_badge, project_join_date, challenge_status, image, saveHandler
 * @returns {ProjectCompleteComponent}
 */

class ProjectCompleteComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imageList: [],
      challengeImage: "",
      showChallengeDetails: false,
      challengeName: "",
      adventureSlug: "",
      projectUserId: undefined,
      prizeImage: "",
      currentChallengeName: ""
    };
  }

  componentDidMount() {
    let formData = new FormData();
    formData.append("project", this.props.projectSlug);
    formData.append("challenge", this.props.challengeSlug);
    formData.append("projectUserId", this.props.projectUserId);
    AxiosConfig.put("/impactprojects/start_new/", formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((res) => {
        this.setState({
          invitedBy: res.data.invited_by,
        });
      })
      .catch();

    // Get completed challenges
    setTimeout(() => {
      AxiosConfig.get(
        `/impactprojects/project/completed_challenges/${this.props.projectSlug}`
      )
        .then((res) => {
          if (res) {
            let imageList = res.data.completed_challenge_list
            for (let i = 0; i < imageList.length; i++) {
              if (this.props.projectUserId === imageList[i].project_user_id) {
                this.setState({
                  currentChallengeName: imageList[i].challenge_name
                })
              }
            }
            this.setState({
              imageList,
            });
          }
        })
        .catch();
    }, 500);
  }
  renderChallengeDetails(
    event,
    challenge_slug,
    challenge_image,
    challengeName,
    adventureSlug,
    projectUserId,
    prizeImage,
    dateStarted
  ) {
    this.setState({
      challengeImage: challenge_image,
      showChallengeDetails: true,
      challengeSlug: challenge_slug,
      challengeName: challengeName,
      adventureSlug: adventureSlug,
      projectUserId: projectUserId,
      prizeImage: prizeImage,
      projectStarted: dateStarted,
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  hideChallengeDetails() {
    this.setState({ showChallengeDetails: false });
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  renderChallengeInfo() {
    const { adventureSlug } = this.state;
    if (adventureSlug === "SPREAD_THE_WORD") {
      return (
        <SpreadTheWordSummary
          projectSlug={this.props.projectSlug}
          challengeSlug={this.state.challengeSlug}
          projectUserId={this.state.projectUserId}
          challengeName={this.state.challengeName}
        />
      );
    } else if (adventureSlug === "LEARN_NEW_SKILL") {
      return (
        <LearnNewSkillSummary
          projectSlug={this.props.projectSlug}
          challengeSlug={this.state.challengeSlug}
          video={this.props.video}
          projectUserId={this.state.projectUserId}
          challengeName={this.state.challengeName}
        />
      );
    } else if (adventureSlug === "DEVELOP_NEW_HABIT") {
      return (
        <DevelopNewHabitSummary
          projectSlug={this.props.projectSlug}
          challengeSlug={this.state.challengeSlug}
          video={this.props.video}
          projectUserId={this.state.projectUserId}
          challengeName={this.state.challengeName}
        />
      );
    } else if (adventureSlug === "VOLUNTEER") {
      return (
        <VolunteerTimeSummary
          projectSlug={this.props.projectSlug}
          challengeSlug={this.state.challengeSlug}
          video={this.props.video}
          projectUserId={this.state.projectUserId}
          challengeName={this.state.challengeName}
        />
      );
    } else if (adventureSlug === "GIVE_A_DONATION") {
      return (
        <GiveADonationSummary
          projectSlug={this.props.projectSlug}
          challengeSlug={this.state.challengeSlug}
          video={this.props.video}
          projectUserId={this.state.projectUserId}
          challengeName={this.state.challengeName}
        />
      );
    } else if (adventureSlug === "RAISE_FUNDS") {
      return (
        <FundraiseSummary
          projectSlug={this.props.projectSlug}
          challengeSlug={this.state.challengeSlug}
          video={this.props.video}
          projectUserId={this.state.projectUserId}
          challengeName={this.state.challengeName}
        />
      );
    } else if (adventureSlug === "RAISE_YOUR_VOICE") {
      return (
        <RaiseYourVoiceSummary
          projectSlug={this.props.projectSlug}
          challengeSlug={this.state.challengeSlug}
          video={this.props.video}
          projectUserId={this.state.projectUserId}
          challengeName={this.state.challengeName}
        />
      );
    } else {
      return null;
    }
  }
  render() {
    var date = new Date(this.state.projectStarted),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    let finalDate = [mnth, day, date.getFullYear()].join("/");
    return (
      <div className="header_main project-complete">
        <div className="page_main">
          <div className="page_info_vr_content_main">
            <ProjectOldInfo vertical={true} project={this.props.projectSlug} />
          </div>
          <div
            className={
              this.state.showChallengeDetails
                ? "page_details_main"
                : "page_details_main show"
            }
          >
            <div className="page_details_content_main">
              <div className="project-banner">
                <ProjectBanner image={this.props.projectBanner} />
              </div>
              <div className="page_info_hr_content_main">
                <ProjectOldInfo
                  project={this.props.projectSlug}
                />
              </div>
              <div className="project-details">
                <div className="insideContent">
                  <h3 className="textHeader">CONGRATULATIONS</h3>
                </div>
              </div>
              <div className="project-form">
                <div className="congratulations-form-inner">
                  <label>
                    You have completed your project goal and have unlocked the
                    project gift. Thank you for helping me make a big difference
                    in the world today!
                  </label>
                  <img src={this.props.image || Project_logo} alt="Avatar" />
                </div>
              </div>
              <div className="challenge-name">
                <label className="textHeader">MISSION ACCOMPLISHED</label>
              </div>
              <label className="d-block text_dark_blue project-name mt-15">
                <b>{this.props.projectName}</b>
              </label>
              <label className="d-block">{this.props.projectMission}</label>
              <label className="text_dark_blue project-name mt-15">
                <b>Accomplishments</b>
              </label>
              {this.props.adventureSlug === "SPREAD_THE_WORD" ? (
                <SpreadTheWordSummary
                  projectSlug={this.props.projectSlug}
                  challengeSlug={this.props.challengeSlug}
                  projectUserId={this.props.projectUserId}
                  challengeName={this.state.challengeName}
                />
              ) : this.props.adventureSlug === "LEARN_NEW_SKILL" ? (
                <LearnNewSkillSummary
                  projectSlug={this.props.projectSlug}
                  challengeSlug={this.props.challengeSlug}
                  video={this.props.video}
                  projectUserId={this.props.projectUserId}
                  challengeName={this.state.currentChallengeName}
                />
              ) : this.props.adventureSlug === "DEVELOP_NEW_HABIT" ? (
                <DevelopNewHabitSummary
                  projectSlug={this.props.projectSlug}
                  challengeSlug={this.props.challengeSlug}
                  video={this.props.video}
                  projectUserId={this.props.projectUserId}
                  challengeName={this.state.currentChallengeName}
                />
              ) : this.props.adventureSlug === "VOLUNTEER" ? (
                <VolunteerTimeSummary
                  projectSlug={this.props.projectSlug}
                  challengeSlug={this.props.challengeSlug}
                  video={this.props.video}
                  projectUserId={this.props.projectUserId}
                  challengeName={this.state.currentChallengeName}
                />
              ) : this.props.adventureSlug === "GIVE_A_DONATION" ? (
                <GiveADonationSummary
                  projectSlug={this.props.projectSlug}
                  challengeSlug={this.props.challengeSlug}
                  video={this.props.video}
                  projectUserId={this.props.projectUserId}
                  challengeName={this.state.currentChallengeName}
                />
              ) : this.props.adventureSlug === "RAISE_FUNDS" ? (
                <FundraiseSummary
                  projectSlug={this.props.projectSlug}
                  challengeSlug={this.props.challengeSlug}
                  video={this.props.video}
                  projectUserId={this.props.projectUserId}
                  challengeName={this.state.currentChallengeName}
                />
              ) : this.props.adventureSlug === "RAISE_YOUR_VOICE" ? (
                <RaiseYourVoiceSummary
                  projectSlug={this.props.projectSlug}
                  challengeSlug={this.props.challengeSlug}
                  video={this.props.video}
                  projectUserId={this.props.projectUserId}
                  challengeName={this.state.currentChallengeName}
                />
              ) : null}
            </div>
            <div className="d-inline-block navigate-done">
              <RoundedButton
                title="&nbsp;&nbsp;&nbsp;CREATE YOUR NEXT CHALLENGE&nbsp;&nbsp;&nbsp;"
                buttonClassName="w-100 background_dark_orange"
                textThemeClassName="text_medium text_white"
                float="none"
                handleOnClick={(event) => this.props.saveHandler(event)}
                borderRadius="6px"
              />
            </div>
            <div className="mt-15 mb-15 page_details_content_main">
              <div className="project-details">
                <div className="insideContent">
                  <h3 className="textHeader">CHALLENGES ACCOMPLISHED</h3>
                </div>
              </div>
              <ul className="challenges-complete">
                {this.state.imageList &&
                  this.state.imageList.map((elm) => (
                    <li>
                      <a
                        href="javascript:void(0)"
                        onClick={(event) =>
                          this.renderChallengeDetails(
                            event,
                            elm.challenge_slug,
                            elm.challenge_image,
                            elm.challenge_name,
                            elm.adventure_slug,
                            elm.project_user_id,
                            elm.project_user_prize,
                            elm.date_started
                          )
                        }
                        style={{
                          backgroundImage: `url(${elm.challenge_image})`,
                        }}
                      >
                        <span>{elm.challenge_name}</span>
                      </a>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
          <div
            className={
              this.state.showChallengeDetails
                ? "page_details_main show"
                : "page_details_main"
            }
          >
            <div className="page_details_content_main">
              <div
                className="mb-15 challenge-img"
                style={{
                  backgroundImage: `url(${this.state.challengeImage}`,
                }}
              ></div>
              <div className="challenge-name">
                <label className="textHeader">{this.state.challengeName}</label>
              </div>
              <div className="d-inline-block challenge-details">
                <label className="d-block text_dark_blue project-name mt-15">
                  <b>Project Date</b>
                </label>
                <label className="d-block project-name">{finalDate}</label>
                <label className="d-block text_dark_blue project-name mt-15">
                  <b>Accomplishments</b>
                </label>
                <Fragment>
                  {this.state.showChallengeDetails
                    ? this.renderChallengeInfo()
                    : null}
                </Fragment>
                <label className="d-block text_dark_blue project-name mt-15">
                  <b>Awards</b>
                </label>
                <div
                  className="prize-img"
                  style={{
                    backgroundImage: `url(${this.state.prizeImage || Project_logo
                      }`,
                  }}
                ></div>
                {this.state.invitedBy ? (
                  <Fragment>
                    <label className="d-block text_dark_blue project-name mt-15">
                      <b>From</b>
                    </label>
                    <label className="d-block project-name">
                      {this.state.invitedBy}
                    </label>
                  </Fragment>
                ) : null}
                <div className="navigate-done">
                  <RoundedButton
                    title="Done"
                    buttonClassName="background_dark_orange"
                    textThemeClassName="text_medium text_white"
                    float="none"
                    handleOnClick={(event) => this.hideChallengeDetails()}
                    borderRadius="6px"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProjectCompleteComponent;
